import { render, staticRenderFns } from "./YuzuncuMaddeyeYararBilgiIstenilmesiTalepEvrakForm.vue?vue&type=template&id=b848c704"
import script from "./YuzuncuMaddeyeYararBilgiIstenilmesiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./YuzuncuMaddeyeYararBilgiIstenilmesiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports